<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <vuexy-logo /> -->
        <h2 class="brand-text text-primary ml-1"></h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Login-->
      <b-col
        lg="6"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
        v-if="!isLogIn"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          xl="9"
          class="px-xl-2 mx-auto mx-xl-0 ml-xl-auto"
        >
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
          </b-card-title>
          <b-card-text class="mb-2 font-weight-bold h2 text-dark">
            الرجاء تسجيل الدخول إلى حسابك
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form class="auth-login-form mt-2" @submit.prevent>
              <!-- email -->
              <b-form-group
                :label="$t('users.email')"
                label-for="login-email"
                label-class="text-dark font-weight-bold mb-1"
                class="mb-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label
                    for="login-password"
                    class="text-dark font-weight-bold mb-1"
                  >
                    {{ $t("users.password") }}
                  </label>
                  <b-link :to="{ name: 'auth-forgot-password-v2' }"> </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <!-- <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group> -->

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                @click="logIn"
                class="mt-3"
              >
                {{ $t("site.login") }}
              </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <span>{{ $t("site.create_new_account") }} </span>
            <b-link :to="{ name: 'Register' }">
              <span>&nbsp;{{ $t("site.create_account") }}</span>
            </b-link>
          </b-card-text>
          <b-card-text class="text-center mt-2">
            <b-link :to="{ name: 'ForgotPassword' }">
              {{ $t("site.Forgot_Password") }}
            </b-link>
          </b-card-text>

          <!-- divider -->
          <!-- <div class="divider my-2">
            <div class="divider-text">or</div>
          </div> -->

          <!-- social buttons -->
          <!-- <div class="auth-footer-btn d-flex justify-content-center">
            <b-button variant="facebook" href="javascript:void(0)">
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button variant="twitter" href="javascript:void(0)">
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button variant="google" href="javascript:void(0)">
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button variant="github" href="javascript:void(0)">
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div> -->
        </b-col>
      </b-col>
      <b-col
        lg="6"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
        v-else
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
          v-if="user.account_type == 'student'"
        >
          <b-form-group
            id="input-group-30"
            :label="$t('edu_programs.my_programs')"
            label-for="input-30"
          >
            <v-select
              dir="rtl"
              id="input-30"
              v-model="eduProgram"
              :reduce="(eduProgram) => eduProgram.id"
              label="name"
              :options="eduPrograms"
              @input="goToHome('student')"
            />
          </b-form-group>
          <!-- divider -->
          <!-- <div class="divider my-2">
            <div class="divider-text">or</div>
          </div> -->
          <!-- <b-btn block variant="primary" @click="goToMaster"
            >دخول منصة الدراسات العليا</b-btn
          > -->
        </b-col>
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
          v-if="user.account_type == 'teacher'"
        >
          <b-form-group
            id="input-group-30"
            :label="$t('edu_programs.my_programs')"
            label-for="input-30"
          >
            <v-select
              dir="rtl"
              id="input-30"
              v-model="eduProgram"
              :reduce="(eduProgram) => eduProgram.id"
              label="name"
              :options="eduPrograms"
              @input="getRooms"
            />
          </b-form-group>
          <b-form-group
            id="input-group-30"
            :label="$t('rooms.rooms')"
            label-for="input-30"
            v-if="user.account_type == 'teacher'"
          >
            <v-select
              dir="rtl"
              id="input-30"
              v-model="room"
              :reduce="(room) => room.id"
              label="name"
              :options="rooms"
              @input="goToHome('teacher')"
            />
          </b-form-group>

          <!-- divider -->
          <template v-if="user.quran_program_supervise == 1">
            <div class="divider my-2">
              <div class="divider-text">OR</div>
            </div>
            <b-btn block variant="info" @click="goToQuran"
              >دخول منصة المقرأة العامة والنظامية</b-btn
            >
          </template>
        </b-col>
      </b-col>
      <!-- /Login-->

      <!-- Left Text-->
      <b-col lg="6" class="d-none d-lg-flex align-items-center p-0">
        <b-img class="bg-image" fluid :src="imgUrl" alt="Login V2" />
      </b-col>
      <!-- /Left Text-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";

import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
// import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Auth from "@/Apis/Auth";
import Swal from "sweetalert2";
const appLoading = document.getElementById("loading-bg");

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      eduProgram: 0,
      isLogIn: false,
      status: "",
      password: "",
      userEmail: "",
      eduPrograms: [],
      sideImg: require("@/assets/images/pages/full-avatar.svg"),
      required,
      email,
      user: {},
      room: 0,
      students: [],
      student: 0,
      program: {},
      master_students: [],
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (MAIN_SERVER_URL.serverUrl.includes("furqn")) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/register-2.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  methods: {
    logIn: async function () {
      this.$refs.loginValidation.validate().then(async (success) => {
        if (success) {
          appLoading.style.display = "block";
          const res = await Auth.logIn(this.userEmail, this.password);
          appLoading.style.transition = "0.8s";
          appLoading.style.opacity = 0;
          appLoading.style.display = "none";
          console.log(res);
          if (res) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: this.$i18n.t("site.successfully"),
              showConfirmButton: false,
              timer: 3000,
            });
            // this.$role.value = Auth.ROLE.name;
            console.log(this);
            this.user = Auth.USER;
            localStorage.removeItem("room");
            localStorage.removeItem("eduProgram");
            localStorage.removeItem("content");
            localStorage.removeItem("courseType");
            localStorage.removeItem("master");
            localStorage.removeItem("quran");
            if (this.user.account_type == "teacher") {
              this.eduPrograms = Auth.EDU_PROGRAMS;
              this.master_students = Auth.MASTER_STUDENTS;
            } else if (this.user.account_type == "student") {
              this.eduPrograms = Auth.EDU_PROGRAMS.filter(
                (a) => a.pivot.status == "approved"
              );
              if (this.user.metaData)this.goToQuran();
              else if (this.eduPrograms.length == 0) {
                this.$router.push({ name: "OnlineApplication" });
              } else if (this.eduPrograms.length == 1) {
                localStorage.setItem("eduProgram", this.eduPrograms[0].id);
                this.$router.push("/");
              }
            }

            if (this.user.account_type == "admin") {
              this.$router.push("/");
            }
            this.isLogIn = true;
            //
          } else {
            Swal.fire({
              position: "center",
              icon: "error",
              title: "Oops...",
              text: res.message,
              showConfirmButton: false,
              timer: 3000,
            });
          }
        }
      });
    },
    goToHome(type) {
      localStorage.setItem("eduProgram", this.eduProgram);

      if (type == "teacher") {
        localStorage.setItem("room", this.room);
      
      }
      this.$router.push("/");
        appLoading.style.display = "none";
    },
    goToQuran() {
      localStorage.setItem("quran", 1);
      if(Auth.USER.account_type=="student"){
        Auth.MENU_ITEMS = quranProgramStudent;
      }else{
      Auth.MENU_ITEMS = quranProgramTeacher;
      }
      this.$router.push("/");
      appLoading.style.display = "none";
    },
    getRooms: function () {
      this.program = this.eduPrograms.find((a) => a.id == this.eduProgram);
      let eduProgram = this.program;
      // if (eduProgram.is_master == 0) {
      if (eduProgram.is_course == 1) {
        localStorage.setItem("eduProgram", this.eduProgram);
        localStorage.setItem("room", eduProgram.rooms[0].id);
        this.$router.push("/");
        appLoading.style.display = "none";
      }
      this.rooms = Auth.ROOM.filter((a) => a.edu_program_id == this.eduProgram);
      // } else {
      //   let master_students_ids = this.master_students.map((el) => el.student.id);
      //   console.log(master_students_ids);
      //   this.students = eduProgram.students.filter((el) =>
      //     master_students_ids.includes(el.id)
      //   );
      //   this.students.forEach((el) => {
      //     el.for_v_select = el.code + " " + el.full_name;
      //   });
      // }
    },
  },
};
</script>

 
<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
@import "@core/scss/vue/libs/vue-select.scss";

.bg-image {
  object-fit: cover;
  width: 100%;
}
</style>